import styled, { css } from 'styled-components';

export default styled('div')`
  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
  ${(props) =>
    props.rotate &&
    css`
      transform: rotate(${props.rotate});
      width: ${props.width};
      margin: ${props.margin};
    `};

  ${(props) =>
    props.iconnomarginleft &&
    css`
      margin-left: 0px;
    `};
`;

export const IconContainer = styled.div`
  margin: ${(props) => props.margin || 'unset'};
  width: ${(props) => props.width};
  color: ${(props) => props.fill};
  display: flex;
  justify-content: center;
  align-items: center;
`;
